export const getFoldingInitialState = () => ({
    enabled: false,
    fields: {
        collection: 'foldingcollection',
        parent: 'foldingparent',
        child: 'foldingchild',
    },
    filterFieldRange: 2,
    collections: {},
});
